import { MRT_Row } from "material-react-table"
import { Skeleton, Box, Grid, Typography, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { AdyenAccountHolder } from "../../adyenTypes"
import { tailwindPalette } from "../../../../../../theme/tailwindPalette"
import { AdyenAccountHoldersDetailsResponse, getAdyenAccountHoldersDetails, SupportAdyenQuery } from "../../adyenApi"
import { useApiQuery } from "../../../../../../../core/api/useApiQuery"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    detailsContainer: {
        marginLeft: "2.2rem",
        paddingLeft: "1rem",
        gap: "1.5rem",

        "&::before": {
            content: '""',
            position: "absolute",
            left: "2.2rem",
            top: 0,
            bottom: 0,
            width: ".125rem",
            backgroundColor: tailwindPalette.slate[200],
            borderRadius: ".25rem",
        },
    },
}))

function transformData(data: AdyenAccountHoldersDetailsResponse) {
    return data.accountHolder
}

export function AccountHolderDetails({ row }: { row: MRT_Row<AdyenAccountHolder> }) {
    const { classes } = useStyles()

    const { data, isLoading } = useApiQuery(getAdyenAccountHoldersDetails, {
        queryName: SupportAdyenQuery.ACCOUNT_HOLDERS_DETAILS,
        dependencies: {
            id: row.original.id,
        },
        select: transformData,
        enabled: Boolean(row.original.id),
    })

    if (isLoading) {
        return <Skeleton width="50%" height={30} />
    }

    return (
        <Box position="relative">
            <Grid container flexDirection="column" className={classes.detailsContainer}>
                <Box>
                    <Stack direction="column" spacing="1.5rem">
                        <Stack direction="column" spacing=".5rem">
                            <LocalizedStrict id="adyen-account-holders-table-details-balance-accounts">
                                <Typography variant="subtitle2">Balance accounts:</Typography>
                            </LocalizedStrict>
                            <Box>
                                {data?.balanceAccounts.map((i) => (
                                    <Typography key={i.id} variant="body2">
                                        {i.id}
                                    </Typography>
                                ))}
                            </Box>
                        </Stack>
                        <Stack direction="column" spacing=".5rem">
                            <LocalizedStrict id="adyen-account-holders-table-details-stores">
                                <Typography variant="subtitle2">Stores:</Typography>
                            </LocalizedStrict>
                            <Box>
                                {data?.stores.map((i) => (
                                    <Typography key={i.id} variant="body2">
                                        {i.id}
                                    </Typography>
                                ))}
                            </Box>
                        </Stack>
                    </Stack>
                </Box>
            </Grid>
        </Box>
    )
}
